import { format, isValid } from 'date-fns';
import { enGB } from 'date-fns/locale';

export default (rawDate, form = 'PP') => {
  const date = new Date(rawDate);
  return isValid(date) ? format(date, form, { locale: enGB }) : '-';
};
